import React, {useEffect, useState} from 'react';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {useTranslation} from "react-i18next";
import {Card, CardActions, CardContent, CardHeader, Typography} from "@mui/material";
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import {Link, useNavigate} from "react-router-dom";
import {connect, setStore} from "trim-redux";
import {
    addressQueryString,
    calculateCartItemPrice,
    calculateCartTotalPrice, calculateTransferPrice,
    currencySymbol,
    getMediaURL,
    price, truncate
} from "../../../../../config/values";
import SubTitle from "../../../../components/elements/SubTitle";
import AddToCartBtn from "../../products/components/AddToCartBtn";
import Title from "../../../../components/elements/Title";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import NothingFound from "../../../../components/elements/NothingFound";
import {ChevronRight, PackageOpen} from "lucide-react";
import CartSkeleton from "../../../../components/loaders/CartSkeleton";
import {LoadingButton} from "@mui/lab";

function CartWidget({classes,user,isAuth,dialog,vendor_id,selected_time,cart_loading,closeDialog}) {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [vendor, setVendor] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [oos, setOOS] = useState(false);
    const [addressError, setAddressError] = useState(false);
    const navigation = useNavigate();
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    };
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () =>{
        setOOS(false);
        axios.get(`${defaultVariables.url}/user/get-cart${!!vendor_id ? "/"+vendor_id : '' }${addressQueryString()}`,config)
            .then(response => {
                let cart = response.data.cart
                setData(cart);
                setVendor(response.data.vendor);
                setAddressError(response.data.address_error)
                if(!!cart){
                    cart.map(item => {
                        if(!!item.out_of_stock){
                            setOOS(true);
                        }
                    })
                }
                setLoading(false);
                setStore({
                    cart_loading:false
                })
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    }

    useEffect(() => {
        if(!!isAuth){
            loadData();
        }else{
            setLoading(false);
        }
    },[user,isAuth]);
    const handleOpenCheckout = () => {
        setSubmitLoading(true);
        axios.get(`${defaultVariables.url}/cart/check${addressQueryString()}`,config)
            .then(response => {
                navigation('/checkout');
                setSubmitLoading(false);
                if(!!dialog){
                    closeDialog();
                }
            })
            .catch(error => {
                enqueueSnackbar(error.response.data, { variant: 'warning' });
                loadData();
                setSubmitLoading(false);
            });
    }
    const handleRemoveItem = (id) => {
        setData((prevData) => prevData.filter((item) => item.id !== id));
      };
    const Actions = () =>{
        let cart_total_price = parseFloat(calculateCartTotalPrice(data));
        let transfer_price = parseFloat(calculateTransferPrice(cart_total_price,vendor));
        let total_prce = cart_total_price + transfer_price;
        let orderIsLow = !!vendor ? vendor.minimum_order > cart_total_price : false;
        return(
            <Grid container spacing={2}>
                <Grid item size={12}>
                    <Typography>
                        <span>{t('total')}:</span>
                        <strong>{price(cart_total_price)} {currencySymbol}</strong>
                    </Typography>
                </Grid>
                <Grid item size={12}>
                    <Typography>
                        <span>{t('transferPrice')}:</span>
                        <strong>{transfer_price === 0 ? t('free') : `${transfer_price} ${currencySymbol}`} </strong>
                    </Typography>
                </Grid>
                <Grid item size={12}>
                    <Typography color="secondary">
                        <span>{t('payable')}:</span>
                        <strong>{price(total_prce)} {currencySymbol}</strong>
                    </Typography>
                </Grid>
                <Grid item size={12}>
                    <LoadingButton
                        className="confirm-btn"
                        variant="contained"
                        size="large"
                        disabled={orderIsLow || (!vendor.is_open && !selected_time) || oos || addressError || cart_loading}
                        onClick={() => handleOpenCheckout()}
                        loading={submitLoading}
                    >
                        {t("confirmCart")}
                    </LoadingButton>
                    {
                        !!orderIsLow &&
                        <Typography style={{marginTop:10}} className="error-text">{t('minimumOrder')}: <strong>{price(vendor.minimum_order)} {currencySymbol}</strong></Typography>

                    }
                    {
                        (!vendor.is_open && !selected_time) &&
                        <Typography style={{marginTop:10}} className="error-text">{t('vendorIsClosedInThisTime')}</Typography>

                    }
                    {
                        (!!oos) &&
                        <Typography style={{marginTop:10}} className="error-text">{t('someItemsAreOutOfStock')}</Typography>

                    }
                    {
                        (!!addressError) &&
                        <Typography style={{marginTop:10}} className="error-text">{t('addressError')}</Typography>

                    }
                </Grid>
            </Grid>
        )
    };
    return (
        <>
            {
                !dialog ?
                    <Card className={classes.cartWidget}>
                        <CardContent>
                            {
                                !dialog &&
                                <Title align="left" color='text'>{t('yourItems')}</Title>
                            }
                            <>
                                {
                                    data.length > 0 ?
                                        <div className={classes.cartProductsContainer} style={{maxHeight: !!dialog ? 300 : 300}}>
                                            {
                                                data.map((item,index) => (
                                                    <div className={classes.cartProduct} key={item.id}>
                                                        <div className="img-holder">
                                                            <img src={getMediaURL(item.product?.thumbnail,'square')} alt={item.product?.name}/>
                                                        </div>
                                                        <div className="content-holder">
                                                            <SubTitle align="left">{truncate(item.product?.name , 15)}</SubTitle>
                                                            <div className='actions'>
                                                                <Typography><strong>{price(calculateCartItemPrice(item))} {currencySymbol}</strong></Typography>
                                                                <AddToCartBtn key={item.id} isRemoved={() => handleRemoveItem(item.id)} in_cart product={item.product} oos={item.out_of_stock}/>
                                                            </div>

                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        :
                                        <>
                                            {
                                                loading ?
                                                    <CartSkeleton/>
                                                    :
                                                    <NothingFound
                                                        type="cart"
                                                        title={t('yourCartIsEmpty')}
                                                        title_color="text"
                                                        paragraph={t('yourCartIsEmptyDesc')}
                                                        icon={<PackageOpen/>}
                                                    />
                                            }
                                        </>

                                }
                            </>
                        </CardContent>
                        {
                            data.length > 0 &&
                            <CardActions className={classes.cartWidgetActions}>
                                <Actions/>
                            </CardActions>
                        }
                    </Card>
                    :
                    <Grid container spacing={2}>
                        <Grid item size={12}>
                            <>
                                {
                                    data.length > 0 ?
                                        <div className={classes.cartProductsContainer} style={{maxHeight: !!dialog ? 500 : 300}}>
                                            {
                                                data.map((item,index) => (
                                                    <div className={classes.cartProduct} key={item.id}>
                                                        <div className="img-holder">
                                                            <img src={getMediaURL(item.product?.thumbnail,'square')} alt={item.product?.name}/>
                                                        </div>
                                                        <div className="content-holder">
                                                            <SubTitle align="left">{item.product?.name}</SubTitle>
                                                            <div className='actions'>
                                                                <Typography><strong>{price(calculateCartItemPrice(item))} {currencySymbol}</strong></Typography>
                                                                <AddToCartBtn isRemoved={() => handleRemoveItem(item.id)} in_cart product={item.product} oos={item.out_of_stock}/>
                                                            </div>

                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        :
                                        <>
                                            {
                                                loading ?
                                                    <CartSkeleton/>
                                                    :
                                                    <NothingFound
                                                        type="cart"
                                                        title={t('yourCartIsEmpty')}
                                                        title_color="text"
                                                        paragraph={t('yourCartIsEmptyDesc')}
                                                        icon={<PackageOpen/>}
                                                    />
                                            }
                                        </>

                                }
                            </>
                        </Grid>
                        {
                            data.length > 0 &&
                            <Grid item size={12}  className={classes.cartWidgetActions}>
                                <Actions/>
                            </Grid>
                        }

                    </Grid>
            }

        </>
    );
}
const mapStateToProps = (state) => ({
    user: state.user,
    isAuth: state.isAuth,
    selected_time: state.selected_time,
    cart_loading: state.cart_loading,
});

export default withStyles(Styles)(connect(mapStateToProps)(CartWidget));
